import { msg } from '../localization/i18n';
import { enumMessageKeys } from '../localization/enumMessages';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const enumWordOverrides: Record<string, string> = {
  ai: 'AI',
  api: 'API',
  id: 'ID',
  rsvp: 'RSVP',
  sms: 'SMS',
  url: 'URL',
};

function capitalizeWord(word: string) {
  const normalizedWord = word.toLowerCase();

  return (
    (Object.hasOwn(enumWordOverrides, normalizedWord)
      ? enumWordOverrides[normalizedWord]
      : undefined) ??
    `${normalizedWord.charAt(0).toUpperCase()}${normalizedWord.slice(1)}`
  );
}

export function formatUntranslatedLabel(
  value: string | null | undefined,
  overrides: Record<string, string> = {},
) {
  if (!value) {
    return '';
  }

  return (Object.hasOwn(overrides, value) ? overrides[value]! : value)
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .split(/[_\-\s]+/)
    .filter(Boolean)
    .map((word) => capitalizeWord(word))
    .join(' ');
}

// Only call this for product enums; user-authored labels use formatUntranslatedLabel.
export function formatEnumLabel(
  value: string | null | undefined,
  overrides: Record<string, string> = {},
) {
  if (!value) return '';
  if (Object.hasOwn(overrides, value)) return overrides[value]!;
  const normalized = value.replace(/([a-z0-9])([A-Z])/g, '$1_$2').toLowerCase();
  const key = Object.hasOwn(enumMessageKeys, normalized)
    ? enumMessageKeys[normalized]
    : undefined;
  return key ? msg(key) : formatUntranslatedLabel(value);
}
